<script setup lang='ts'>
import { computed } from 'vue';

interface SvgIconProps {
  directory?: string;
  name: string;
  className?: string;
  size?: number;
  width?: string;
  height?: string;
  fill?: string;
  stroke?: string | boolean;
  color?: string;
}

const props = withDefaults(defineProps<SvgIconProps>(), {
  size: 16,
  fill: 'inherit'
});

const symboId = computed(() => {
  if (props.directory) {
    return `#icon-${props.directory}-${props.name}`;
  }
  return `#icon-${props.name}`;
});

const width = computed(() => {
  return props.width || props.size + 'px';
});

const height = computed(() => {
  return props.height || props.size + 'px';
});

const stroke = computed(() => {
  if (typeof props.stroke === 'string') {
    return props.stroke;
  } else if (props.stroke === true) {
    return props.fill;
  }
  return undefined;
});
</script>

<template>
  <svg :class="['svg-icon', props.className]" :style="{ color }" :inert="true">
    <use :xlink:href="symboId" :fill="fill" :stroke="stroke" />
  </svg>
</template>

<style lang="less" scoped>
.svg-icon {
  width: v-bind(width);
  height: v-bind(height);
}
</style>